// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"c61a040f","484":"8f341379"}[chunkId] + ".chunk.js";
};